import type { ComponentType } from 'react'

export function withStyleModifiers<T extends ComponentType<any>, M>(Component: T, modifiers: M): T & M {
  return Object.assign<T, M>(Component, modifiers)
}
